/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Plan_UnsupportedInputs */

const es_co2_error_plan_unsupported = /** @type {(inputs: Error_Plan_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plan no es válido.`)
};

/**

* @param {Error_Plan_UnsupportedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_plan_unsupported = /** @type {((inputs?: Error_Plan_UnsupportedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Plan_UnsupportedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_plan_unsupported(inputs)
});